import { CreatePassengerDto, FormPassengerDto, RowPassengerDto, UpdatePassengerDto } from "@/dtos";
import { getContacts, getIdenficationDto } from "../auth/administrator.format";
import { Identification, Passenger } from "@/entities";
import { ContactType } from "@/helpers/types";

export const formatPassengerDto = (form: FormPassengerDto, isCreate: boolean) => {
    const passengerDto = {
        first_name: form.first_name,
        last_name: form.last_name,
        identification: form.identification ? getIdenficationDto(form) : {} as Identification,
        contact: getContacts(form),
        is_sync_clipp: form.is_sync_clipp,
        balance: form.balance * 100
    }

    return (isCreate) ? passengerDto as CreatePassengerDto : passengerDto as UpdatePassengerDto;
}

export const formatRowPassengerDto = (passengers: Passenger[]): RowPassengerDto[] => {
    return passengers.map(x => {
        const row: RowPassengerDto = {
            ...x,
            dni: (x.identification && x.identification.identification != '') ? x.identification.identification : 'S/N',
            email: x.contact?.find((x) => x.type == ContactType.EMAIL)?.identification ?? 'S/N',
            cellphone: x.contact?.find((x) => x.type == ContactType.CELLPHONE)?.identification ?? 'S/N',
            active: x.is_active ? 'Activo' : 'Inactivo',
            is_sync_clipp_label: x.is_sync_clipp ? 'Si' : 'No',
            amount_payment_methods: x.payment_methods.length,
            has_payment_methods: x.payment_methods.length > 0 ? 'Si' : 'No'
        }

        return row;
    });
}